import axios from './axiosConfig'
import type { LoginBody, LoginResponse, BaseResponse } from '@/types'

export const getVerifyCodeService = () => {
  return axios.get('/user/getVerifyCode', {
    responseType: 'blob'
  })
}

export const loginService = (data: LoginBody): Promise<LoginResponse> => {
  return axios.post('/user/login', data)
}

export const logoutService = (): Promise<BaseResponse> => {
  return axios.post('/user/loginOut')
}

export const resetPasswordService = (data: { sn: string }): Promise<BaseResponse> => {
  return axios.post('/user/resetPassword', data)
}
